import { render } from "./UpdatePasswordModal.vue?vue&type=template&id=606089e6"
import script from "./UpdatePasswordModal.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__